import { DOCUMENT, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-machine-learning',
  templateUrl: './machine-learning.component.html',
  styleUrls: ['./machine-learning.component.css']
})
export class MachineLearningComponent {
  isOpen: boolean[] = [];
  imageItems1 = [
    { src: "../../../assets/images/machine-learning-images/img-2.webp"  }
    // Add more items as needed
  ];

  imageItems2 = [
    { src: "../../../assets/images/machine-learning-images/img-3.webp"  }
    // Add more items as needed
  ];
  imageItems3 = [
    { src: "../../../assets/images/machine-learning-images/img-4.webp " }
    // Add more items as needed
  ];
  imageItems4 =[
    {
      src: "../../../assets/images/machine-learning-images/img-5.webp "
    }
  ]

  enlargedImageSrc: string | null = null;
  isEnlargedVisible = false;
  currentIndex = 0;
  currentImageList: 'imageItems1' | 'imageItems2' |'imageItems3' | 'imageItems4' = 'imageItems1';
  isBrowser:boolean=false;


  showEnlargedImage(src: string): void {
    this.enlargedImageSrc = src;
    this.currentIndex = (this[this.currentImageList] as Array<{ src: string }>)
      .findIndex(item => item.src === src);
    this.isEnlargedVisible = true;
  }

  hideEnlargedImage(): void {
    this.isEnlargedVisible = false;
  }

  prevImage(): void {
    const currentList = this[this.currentImageList] as Array<{ src: string }>;
    if (currentList.length > 0) {
      this.currentIndex = (this.currentIndex - 1 + currentList.length) % currentList.length;
      this.enlargedImageSrc = currentList[this.currentIndex].src;
    }
  }

  nextImage(): void {
    const currentList = this[this.currentImageList] as Array<{ src: string }>;
    if (currentList.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % currentList.length;
      this.enlargedImageSrc = currentList[this.currentIndex].src;
    }
  }

  setCurrentImageList(list: 'imageItems1' | 'imageItems2' |'imageItems3' | 'imageItems4' ): void {
    this.currentImageList = list;
    this.enlargedImageSrc = null; // Clear enlarged image when changing lists
    this.isEnlargedVisible = false; // Hide enlarged view when changing lists
  }
  constructor(private viewportScroller: ViewportScroller, private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
  private _renderer2: Renderer2, private seoService:SeoService,
  @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta) {this.isBrowser=isPlatformBrowser(this.platformId);
      this.isOpen = new Array(this.accordionItems.length).fill(false);
    }
scrollToSection(sectionId: string): void {
  this.viewportScroller.scrollToAnchor(sectionId);
}
ngOnInit() {
  let script = this._renderer2.createElement('script');
script.type = `application/ld+json`;
script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/machine-learning/"
  },
  "headline": "Machine learning-powered recommendation engines",
  "description": "Explore the forefront of innovation with Maganti IT as we redefine the landscape of manufacturing E-commerce personalisation.",
  "image": "https://mitresource.com/assets/images/banners/Machine-learning-banner-img.webp",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-03-05"
}`;

this._renderer2.appendChild(this._document.head, script);
  this.setTitleAndMetaTags();
  this.seoService.createLinkForCanonicalURL();
  if(this.isBrowser){     
    AOS.init({disable: 'mobile'});
  
}
}
baseUrl=Constants.baseUrl;

private setTitleAndMetaTags(): void {
  this.titleService.setTitle('Machine learning-powered recommendation engines');

  this.metaService.addTags([
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: 'Machine learning-powered recommendation engines' },
    { property: 'og:url', content: 'https://mitresource.com/machine-learning/' },
    { property: 'og:image', content: 'https://mitresource.com/assets/images/machine-learning-images/img-1.webp' },
    { property: 'og:description', content: 'Over the years, we\'ve all fallen into the trap of overbuying from our favorite e-commerce stores, thanks to those enticing personalized recommendations that seem to know exactly what we\'re looking for.' },
  ]);
}

accordionItems = [
  {
    title: 'Increased sales',
    content: 'By providing personalized recommendations, businesses can increase sales through upselling and cross-selling techniques. This can be measured by comparing sales before and after the implementation of the recommendation engine. For example, if a business experiences a 20% increase in sales after implementing a recommendation engine, and the average monthly sales were $100,000 before implementation, the increased sales would amount to $20,000 per month.'
  },
  {
    title: 'Improved user experience',
    content:'User engagement metrics such as time spent on the platform, click-through rates, and conversion rates can indicate an improved user experience. For instance, if the average time spent on the platform increases from 10 minutes to 15 minutes after implementing recommendation features, it indicates improved user engagement.'
  },
  {
    title: 'Better product discovery',
    content: 'The percentage of users interacting with recommended products compared to non-recommended products can quantify the effectiveness of the recommendation engine in aiding product discovery. For example, if 70% of users engage with recommended products compared to only 30% with non-recommended products, it indicates better product discovery.'
  },
  {
    title: 'Higher customer retention',
    content: 'Customer retention rate can be calculated by dividing the number of customers at the end of a period by the number of customers at the start of the period and multiplying by 100. After implementing a recommendation engine, if the customer retention rate increases from 70% to 80%, it indicates higher customer retention.'
  },
  {
    title:'Reduced churn',
    content:'Churn rate measures the percentage of customers who stop using a product or service within a given time period. If the churn rate decreases from 10% to 5% after implementing a recommendation engine, it indicates reduced churn.'
  }
];
toggleAccordion(index: number): void {
  this.isOpen[index] = !this.isOpen[index];
}

}